import { render, staticRenderFns } from "./DialogAddEditTip.vue?vue&type=template&id=bc04f502"
import script from "./DialogAddEditTip.vue?vue&type=script&lang=js"
export * from "./DialogAddEditTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports